import { token } from "@may-i/mash-design-system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("shared");

  return (
    <PageContainer>
      <Content>
        <TextGroup>
          <ErrorCode>{t("notFound.code")}</ErrorCode>
          <Description>{t("notFound.description")}</Description>
        </TextGroup>
        <HomeButton onClick={() => navigate("/", { replace: true })}>
          {t("notFound.homeButton")}
        </HomeButton>
      </Content>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${token("colors.gray.white")};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ErrorCode = styled.h1`
  margin: 0;
  text-align: center;
  font-family: Pretendard;
  font-size: 72px;
  font-weight: 900;
  line-height: 100%;
  color: ${token("colors.brand.MB500")};
`;

const Description = styled.p`
  margin: 0;
  text-align: center;
  white-space: pre-line;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  color: ${token("colors.text.secondary")};
`;

const HomeButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 22px;
  border: none;
  border-radius: 8px;
  background: ${token("colors.brand.MB500")};
  color: ${token("colors.gray.white")};
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
`;
